export default {};
export const URL = {};
export const URLSearchParams = {};
export const Url = {};
export const domainToASCII = {};
export const domainToUnicode = {};
export const fileURLToPath = {};
export const format = {};
export const parse = {};
export const pathToFileURL = {};
export const resolve = {};
export const resolveObject = {};
export const urlToHttpOptions = {};